import React from "react";
import PropTypes from "prop-types";

const LendbotDisabled = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.92105 11.7H3.28947V20.8H5.92105V11.7ZM13.8158 11.7H11.1842V20.8H13.8158V11.7ZM25 23.4H0V26H25V23.4ZM21.7105 11.7H19.0789V20.8H21.7105V11.7ZM12.5 2.938L19.3553 6.5H5.64474L12.5 2.938ZM12.5 0L0 6.5V9.1H25V6.5L12.5 0Z"
        fill="#BCBEC6"
      />
    </svg>
  );
};

LendbotDisabled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

LendbotDisabled.defaultProps = {
  className: undefined,
  style: undefined,
};

export default LendbotDisabled;
